import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkillSelectWidgitComponent } from './skill-select-widgit/skill-select-widgit.component';


import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';


import { MatFormFieldModule } from '@angular/material/form-field';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { AgmCoreModule } from '@agm/core';
import { SkillListWidgetComponent } from './skill-list-widget/skill-list-widget.component';

import { BarRatingModule } from "ngx-bar-rating";
import { BondShowWidgetComponent } from './bond-show-widget/bond-show-widget.component';
import { UserIconComponent } from './user-icon/user-icon.component';

import { PickLocationComponent } from './pick-location/pick-location.component';
import { AddCommentComponent } from './add-comment/add-comment.component';
import { ListCommentsComponent } from './list-comments/list-comments.component';
import { CreateProjectComponent } from './project/create-project/create-project.component';
import { ProjectsComponent } from './project/projects/projects.component';
import { TasksComponent } from './tasks/tasks.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ShareProjectComponent } from './project/share-project/share-project.component';
import { AlertComponent } from './alert/alert.component';
import { ChatbotComponent } from './chatbot/chatbot.component';
// import { FileIconsModule } from 'ngx-file-icons';
import { ImagePipe } from './pipes/image.pipe';
import { FilterUserPipe } from './pipes/filter.pipe';
import { UserByIdPipe } from './pipes/userById.pipe';
import { DateFormatPipe } from './pipes/date.pipe';
import { SuggestNewSkillComponent } from './suggest-new-skill/suggest-new-skill.component';
import { PublicPostComponent } from './public-post/public-post.component';

@NgModule({
  declarations: [
    SkillSelectWidgitComponent,
    SkillListWidgetComponent,
    BondShowWidgetComponent,
    UserIconComponent,
    PickLocationComponent,
    AddCommentComponent,
    ListCommentsComponent,
    CreateProjectComponent,
    ProjectsComponent,
    TasksComponent,
    ShareProjectComponent,
    AlertComponent,
    ChatbotComponent,
    ImagePipe,
    FilterUserPipe,
    UserByIdPipe,
    DateFormatPipe,
    SuggestNewSkillComponent,
    PublicPostComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIconModule,
    MatCheckboxModule,
    MatTreeModule,
    MatListModule,
    MatTableModule,
    BarRatingModule,
    MatFormFieldModule,
    // AgmCoreModule,
    MatGridListModule,
    MatChipsModule,
    MatProgressBarModule,
    MatDialogModule,
    MatOptionModule,
    MatSelectModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    DragDropModule,
    MatSnackBarModule,
    // FileIconsModule
  ],
  exports: [
    SkillSelectWidgitComponent,
    SkillListWidgetComponent,
    BondShowWidgetComponent,
    PickLocationComponent,
    AddCommentComponent,
    ListCommentsComponent,
    CreateProjectComponent,
    ProjectsComponent,
    TasksComponent,
    ShareProjectComponent,
    ChatbotComponent,
    DateFormatPipe,
    SuggestNewSkillComponent,
  ]
})
export class SharedModule { }
